const files = require.context('./', true, /\.js$/)
let apis = {}
files.keys().forEach(key => {
  apis = Object.assign(apis, files(key).default)
  // modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
export default apis
